import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "points-config"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("批量修改");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("设置积分");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("积分/盒");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("积分/盒");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("积分/盒");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确认");

import { reactive, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { getVexTableProps } from '@/config';
import { getSupplierMerchandiseIntegraList, saveMerchandiseIntegralConfig } from '@/request';
import InputNumber from '@/components/input/input-number.vue';
import { ElMessage } from 'element-plus';
export default {
  name: 'pointsConfig',

  setup(__props) {
    const route = useRoute();
    const {
      supplierId
    } = route.query;
    const search = reactive({
      prodName: '',
      prodNo: '',
      manufacturer: '',
      status: ''
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      loading: false,
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '操作',
        width: '100px',
        fixed: 'left',
        slots: {
          default: 'operation'
        }
      }, {
        title: '药品名称',
        field: 'prodName'
      }, {
        title: '药品编号',
        field: 'prodNo'
      }, {
        title: '品规',
        field: 'prodSpecification'
      }, {
        title: '价格',
        field: 'salePrice'
      }, {
        title: '厂家',
        field: 'manufacturer'
      }, {
        title: '积分规则',
        field: 'integralRule'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            let params = _objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              supplierId
            }, search);

            getSupplierMerchandiseIntegraList(params).then(response => {
              let {
                merchandiseIntegralInfoVoList = [],
                totalSize
              } = response.data;
              res({
                total: totalSize,
                result: merchandiseIntegralInfoVoList
              });
            });
          })
        }
      }
    });

    function settingHandle(type, row) {
      if (type === 'single') {
        dialog.value = {
          visible: true,
          type,
          prodNos: row.prodNo
        };
        dialogForm.value = {
          firstLevelIntegral: row.firstLevelIntegral,
          secondLevelIntegral: row.secondLevelIntegral,
          thirdLevelIntegral: row.thirdLevelIntegral
        };
        return;
      } // 批量设置


      let selectRows = table.value.getCheckboxRecords();

      if (selectRows.length === 0) {
        ElMessage.warning('请选择药品');
        return;
      }

      dialog.value = {
        visible: true,
        type,
        prodNos: selectRows.map(v => v.prodNo).join()
      };
      dialogForm.value = {
        firstLevelIntegral: '',
        secondLevelIntegral: '',
        thirdLevelIntegral: ''
      };
    }

    function resetHandle() {
      Object.keys(search).forEach(key => {
        search[key] = '';
      });
      table.value.commitProxy('reload');
    } // 设置积分dialog


    const dialog = ref({
      visible: false,
      type: '',
      prodNos: ''
    });
    const dialogTitle = computed(() => dialog.value.type === 'multiple' ? '批量设置积分' : '设置积分');
    const dialogForm = ref({
      firstLevelIntegral: '',
      secondLevelIntegral: '',
      thirdLevelIntegral: ''
    });
    const formEl = ref();
    const dialogFormRules = {
      firstLevelIntegral: {
        required: true,
        message: '请设置一级积分'
      },
      secondLevelIntegral: {
        required: true,
        message: '请设置二级积分'
      },
      thirdLevelIntegral: {
        required: true,
        message: '请设置三级积分'
      }
    };

    function close() {
      dialog.value.visible = false;
    }

    function submit() {
      formEl.value.validate(valid => {
        if (!valid) return;

        let body = _objectSpread({
          supplierId,
          prodNos: dialog.value.prodNos
        }, dialogForm.value);

        saveMerchandiseIntegralConfig(body).then(res => {
          let {
            success
          } = res;

          if (success) {
            ElMessage.success('操作成功');
            table.value.commitProxy('query');
            close();
            return;
          }

          ElMessage.error('操作失败');
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "药品名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: search.prodName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.prodName = $event),
                placeholder: "请输入药品名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "药品编号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: search.prodNo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.prodNo = $event),
                placeholder: "请输入药品编号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "厂家"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: search.manufacturer,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.manufacturer = $event),
                placeholder: "请输入厂家名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: search.status,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.status = $event),
                placeholder: "全部"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  value: "",
                  label: "全部"
                }), _createVNode(_component_el_option, {
                  value: 1,
                  label: "已设置"
                }), _createVNode(_component_el_option, {
                  value: 0,
                  label: "未设置"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          justify: "end"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: resetHandle
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = $event => settingHandle('multiple'))
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: $event => settingHandle('single', row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        modelValue: dialog.value.visible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => dialog.value.visible = $event),
        title: _unref(dialogTitle),
        width: "600px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        default: _withCtx(() => [dialog.value.visible ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          model: dialogForm.value,
          rules: dialogFormRules,
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "第三级（下单业务员）：",
            prop: "thirdLevelIntegral"
          }, {
            default: _withCtx(() => [_createVNode(InputNumber, {
              modelValue: dialogForm.value.thirdLevelIntegral,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dialogForm.value.thirdLevelIntegral = $event),
              type: "number",
              precision: 2,
              max: 9999
            }, {
              append: _withCtx(() => [_hoisted_6]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "第二级：",
            prop: "secondLevelIntegral",
            type: "number"
          }, {
            default: _withCtx(() => [_createVNode(InputNumber, {
              modelValue: dialogForm.value.secondLevelIntegral,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => dialogForm.value.secondLevelIntegral = $event),
              type: "number",
              precision: 2,
              max: 9999
            }, {
              append: _withCtx(() => [_hoisted_7]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "第一级：",
            prop: "firstLevelIntegral",
            type: "number"
          }, {
            default: _withCtx(() => [_createVNode(InputNumber, {
              modelValue: dialogForm.value.firstLevelIntegral,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dialogForm.value.firstLevelIntegral = $event),
              type: "number",
              precision: 2,
              max: 9999
            }, {
              append: _withCtx(() => [_hoisted_8]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }

};